<template>
  <div class="main-container">
    <!-- 固定头部信息 -->
    <div class="header-section">
      <div class="back">
        <button class="back-button" @click="handleBack">
          <i class="iconfont icon-fanhuiicon mr5"></i> 返回
        </button>
      </div>
    </div>
    <!-- 主要内容区域 -->
    <div class="content-wrapper">
      <h3 style="text-align: center; margin-bottom: 30px; font-size: 20px; font-weight: 600; color: #333;">{{ categoryInfo ? categoryInfo.categoryName : '-' }}申请</h3>
      <div class="content-steps">
        <!-- 步骤导航 -->
        <Steps :current="current" :style="{ marginBottom: '30px' }" @change="handleStepChange">
          <Step title="基本信息"/>
          <Step title="低速无人驾驶车辆（装备）"/>
          <Step title="安全员"/>
          <Step title="申请材料"/>
        </Steps>
      </div>

      <!-- 表单内容 -->
      <Form ref="formRef" layout="vertical">
        <!-- 第一步：基本信息 -->
        <BaseForm
          v-if="current === 0"
          :form-data="formData"
          :test-area-routes="testAreaRoutes"
          :validity-period-options="validityPeriodOptions"
          :test-area-columns="testAreaColumns"
          @add-route="handleAddTestingAreaRoute"
          @delete-route="handleDeletetestAreaRoute"
        />

        <!-- 第二步：车辆信息 -->
        <VehicleForm
          v-if="current === 1"
          :test-vehicle-type-list="testVehicleTypeList"
          :vehicle-data="vehicleData"
          :is-selected="vehicleIsSelected"
          @select-vehicle="openVehicleSelectModal"
          @reset-vehicle="resetVehicleData"
        />

        <!-- 第三步：安全员信息 -->
        <SecurityUserForm
          v-if="current === 2"
          v-model:security-users="securityUsers"
        />

        <!-- 第四步：申请材料 -->
        <MaterialForm
          v-if="current === 3"
          :application-material-list="applicationMaterialList"
          :category-info="categoryInfo"
          @download-template="downloadTemplate"
          @update-files="handleFilesUpdate"
          @upload-success="handleUploadSuccess"
          @delete-file="handleFileDelete"
          @notice-agree="handleNoticeAgree"
        />
        <!-- 操作按钮 -->
        <div class="form-actions">
          <Button v-if="current > 0" @click="prev" style="margin-right: 8px;">
            上一步
          </Button>
          <Button v-if="current < 3" type="primary" style="margin-right: 8px;" @click="next">
            下一步
          </Button>
          <Button v-if="current === 3" type="primary" style="margin-right: 8px;" @click="handleSave">
            保存
          </Button>
          <Button v-if="current === 3" type="primary" @click="handleSubmit">
            提交申请
          </Button>
        </div>
      </Form>
    </div>
    <!-- 测试区域选择弹框 -->
    <OpenAreaSelectModel
        v-model:visible="testAreaRouteModalVisible"
        v-model:category-code="categoryCode"
        :selected-routes="testAreaRoutes"
        @confirm="handleTestingAreaRouteSelect"

    />

    <VehicleSelectModel
        :visible="vehicleSelectModalVisible"
        @selectedEvent="handleVehicleSelect"
        @cancelEvent="vehicleSelectModalVisible = false"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import { message } from 'ant-design-vue';
import { Steps, Form, Button } from 'ant-design-vue';
import { useRouter, useRoute } from 'vue-router';
import MaterialFileManager from '@/components/MaterialFileManager/index.vue';
import { getCategory } from '@/api/settings/category';
import { getVehicleTypeList } from '@/api/settings/vehicleType';
import { getApplicationMaterialsByCategory } from '@/api/settings/applicationMaterials';
import { testApplication, getTestApplication } from '@/api/application/testApplication';

import OpenAreaSelectModel from '../components/OpenAreaSelectModel.vue';
import VehicleSelectModel from './components/VehicleSelectModel.vue';
import BaseForm from './components/BaseForm.vue';
import VehicleForm from './components/VehicleForm.vue';
import SecurityUserForm from './components/SecurityUserForm.vue';
import MaterialForm from './components/MaterialForm.vue';

const router = useRouter();
const route = useRoute();

const { Step } = Steps;

// 获取路由参数中的type值和code值
const categoryId = ref('');
const categoryType = ref(route.query.type || '');
const categoryCode = ref(route.query.code || '');
const categoryInfo = ref(null);

const applicationId = ref(route.query.id || '');

// 当前步骤
const current = ref(0);
// 表单引用
const formRef = ref();
// 是否同意申请须知
const agreedToNotice = ref(false);
// 单车辆表单数据
const vehicleData = reactive({
  id: null,
  vin: '',
  model: '',
  type: '',
  manufacturer: '',
  productionDate: ''
});

// 人员表单数据 - 改为数组，支持多个安全员
const securityUsers = ref([]);

// 车辆是否已选择
const vehicleIsSelected = ref(false);

// 返回
const handleBack = () => {
  router.push('/application/index');
};

// 有效期选项
const validityPeriodOptions = [
  { value: 1, label: '1个月' },
  { value: 3, label: '3个月' },
  { value: 6, label: '6个月' }
];

// 表单数据
const formData = reactive({
  id: '',
  categoryId: categoryId.value,
  categoryType: categoryType.value,
  categoryCode: categoryCode.value,
  startDate: '',
  months: null,
  endDate: '',
  status: 0,
  testAreaRoutes: [],
  vehicle: {},
  securityUsers: [],
  applicationMaterialList: [],
});

// 测试路线数据=================================================
const testAreaRoutes = ref(formData.testAreaRoutes);

// 测试路线表格列配置
const testAreaColumns = [
  {
    title: '测试区域',
    dataIndex: 'areaName',
    key: 'areaName'
  },
  {
    title: '测试路线',
    dataIndex: 'routeName',
    key: 'routeName'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: 160
  }
];


// 测试区域选择弹框控制
const testAreaRouteModalVisible = ref(false);

// 打开测试区域选择弹框
const handleAddTestingAreaRoute = () => {
  testAreaRouteModalVisible.value = true;
};

// 处理测试区域选择结果
const handleTestingAreaRouteSelect = (selectedData) => {
  // 处理多选后的routes数组
  console.log("selectedData", selectedData)
  if (selectedData && selectedData.routes && selectedData.routes.length > 0) {
    // 遍历所有选中的路线
    selectedData.routes.forEach(route => {
      // 为每条路线创建新的数据项
      const newRoute = {
        key: route.routeId, // 确保key唯一性
        areaId: route.areaId || selectedData.areaId,
        areaName: route.areaName || selectedData.areaName,
        routeId: route.routeId,
        routeName: route.name,
      };

      // 检查是否已存在相同的路线
      const exists = testAreaRoutes.value.some(item => item.routeId === newRoute.routeId);
      if (!exists) {
        testAreaRoutes.value.push(newRoute);
      }
    });
  }
  testAreaRouteModalVisible.value = false;
};

// 删除测试路线
const handleDeletetestAreaRoute = (key) => {
  const index = testAreaRoutes.value.findIndex(item => item.key === key);
  if (index !== -1) {
    testAreaRoutes.value.splice(index, 1);
  }
};

// 测试车辆数据=================================================
const testVehicleTypeList = ref([]);

// 打开车辆选择弹框
const openVehicleSelectModal = () => {
  vehicleSelectModalVisible.value = true;
};

const handleVehicleSelect = (selectedVehicle) => {
  if (selectedVehicle) {
    vehicleData.id = selectedVehicle.id || '';
    vehicleData.vin = selectedVehicle.vin || '';
    vehicleData.model = selectedVehicle.model || '';
    vehicleData.type = selectedVehicle.type || '';
    vehicleData.manufacturer = selectedVehicle.manufacturer || '';
    vehicleData.productionDate = selectedVehicle.productionDate || '';
    vehicleIsSelected.value = true;
    message.success('车辆选择成功');
    vehicleSelectModalVisible.value = false;
  }
};

const resetVehicleData = () => {
  vehicleData.id = null;
  vehicleData.vin = '';
  vehicleData.model = '';
  vehicleData.type = '';
  vehicleData.manufacturer = '';
  vehicleData.productionDate = '';
  vehicleIsSelected.value = false;
};

// 车辆选择弹框控制
const vehicleSelectModalVisible = ref(false);

// 申请材料列表=================================================
const applicationMaterialList = ref();

// 下载模板
const downloadTemplate = (materialId) => {
  // 模拟下载模板的逻辑
  message.success('模板下载成功！');
};

// 处理文件列表更新
const handleFilesUpdate = (materialId, files) => {
  console.log('文件列表已更新:', files.length, '材料ID:', materialId);
  //const material = applicationMaterialList?.value?.find(item => item.materialId === materialId);
  // if (material) {
  //   material.files = files;
  // }
};

// 处理文件上传成功
const handleUploadSuccess = (file, materialId) => {
  console.log('文件上传成功:', file.name, '材料ID:', materialId);
  // 在文件上传成功后，查找对应的材料并更新其files属性
  const material = applicationMaterialList?.value?.find(item => item.materialId === materialId);
  if (material) {
    // 确保files是数组
    if (!Array.isArray(material.files)) {
      material.files = [];
    }
    // 检查是否已存在相同uid的文件，如果不存在则添加
    const existingFileIndex = material.files.findIndex(f => f.uid === file.uid);
    if (existingFileIndex === -1) {
      material.files.push(file);
    } else {
      // 如果文件已存在，则更新它
      material.files[existingFileIndex] = file;
    }
    // 按文件名排序
    material.files.sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));
  }
};

// 处理文件删除
const handleFileDelete = (file, materialId) => {
  console.log('文件删除:', file.name, '材料ID:', materialId);
  // 在文件删除后，查找对应的材料并更新其files属性
  const material = applicationMaterialList?.value?.find(item => item.materialId === materialId);
  if (material && Array.isArray(material.files)) {
    // 过滤掉要删除的文件
    material.files = material.files.filter(f => f.uid !== file.uid);
    console.info(material.files, "material.files after delete");
  }
};

// 下一步
const next = () => {
  // 表单验证
  if (current.value < 3) {
    current.value++;
  }
};

// 处理步骤点击切换
const handleStepChange = (currentStep) => {
  // 可以在这里添加验证逻辑，控制是否允许跳转到特定步骤
  current.value = currentStep;
};

// 上一步
const prev = () => {
  if (current.value > 0) {
    current.value--;
  }
};

// 处理同意申请须知
const handleNoticeAgree = (e) => {
  agreedToNotice.value = e.target.checked;
};

const handleSave = () => {

  formatFormData()
  formData.status = 0;
  console.log('保存的数据:', formData);

  // 这里可以添加API调用逻辑
  testApplication(formData).then(res =>{
    if (res.code === 200 && res.data){
      message.success('道路测试保存成功！');
      formData.id = res.data
    }
  })
}

// 提交申请
const handleSubmit = () => {
  // 验证是否同意申请须知
  if (current.value === 3 && !agreedToNotice.value) {
    message.warning('请阅读并同意申请须知内容');
    return;
  }
  formatFormData()
  formData.status = 1;
  console.log('提交数据:', formData);

  // 这里可以添加API调用逻辑
  testApplication(formData).then(res =>{
    if (res.code === 200 && res.data){
      message.success('道路测试申请提交成功！');
      formData.id = res.data;
      router.push("/application/index");
    }
  })
};

const formatFormData = () => {
  // 将单车辆表单数据直接赋值
  const vehicle = {};
  if (vehicleData.vin) {
    Object.assign(vehicle, vehicleData);
  }

  // 将安全员数组赋值，每个安全员添加车辆识别代码，过滤空数据
  const securityUsersList = securityUsers.value
    .filter(user => user.name || user.id)
    .map(user => ({
      ...user,
      vin: vehicleData.vin
    }));

  formData.testAreaRoutes = testAreaRoutes.value;
  formData.vehicle = vehicle;
  formData.securityUsers = securityUsersList;
  formData.applicationMaterialList = applicationMaterialList.value;
}

// 根据ID获取申请信息
const fetchApplicationData = async (id) => {
  if (!id) return;

  try {
    const response = await getTestApplication(id);
    if (response.code === 200 && response.data) {
      const data = response.data;

      // 填充表单数据
      formData.id = data.id || '';
      formData.categoryId = data.categoryId || '';
      formData.categoryType = data.categoryType || '';
      formData.categoryCode = data.categoryCode || '';
      formData.startDate = data.startDate || '';
      formData.months = data.months || null;
      formData.endDate = data.endDate || '';
      formData.status = data.status || 0;

      // 更新测试路线
      if (data.testAreaRoutes && Array.isArray(data.testAreaRoutes)) {
        testAreaRoutes.value = data.testAreaRoutes.map(route => ({
          ...route
        }));
      }

      // 更新车辆数据
      if (data.vehicle) {
        Object.assign(vehicleData, data.vehicle);
      }

      // 更新人员数据
      if (data.securityUsers && Array.isArray(data.securityUsers)) {
        securityUsers.value = data.securityUsers;
      }

      // 更新申请材料列表
      if (data.applicationMaterialList && Array.isArray(data.applicationMaterialList)) {
        applicationMaterialList.value = data.applicationMaterialList;
      }
    }
  } catch (error) {
    console.error('获取申请信息失败:', error);
    message.error('加载申请信息失败，请重试');
  }
};

// 查询测试分类信息
const fetchCategoryInfo = async () => {
  try {
    if (!categoryType.value || !categoryCode.value) {
      console.warn('缺少必要的路由参数');
      return;
    }
    const response = await getCategory(categoryType.value, categoryCode.value);
    if (response.code === 200 && response.data) {
      categoryInfo.value = response.data;
    } else {
      message.error('获取分类信息失败');
    }
  } catch (error) {
    console.error('查询分类信息时出错:', error);
  }
};

//获取测试申请材料列表
const fetchApplicationMaterials = async () => {
  try {
    if (!categoryCode.value) {
      console.warn('缺少必要的路由参数');
      return;
    }
    const response = await getApplicationMaterialsByCategory(categoryCode.value);
    if (response.code === 200 && response.data) {
      applicationMaterialList.value = response.data;
    } else {
      message.error('获取测试申请材料列表失败');
    }
  } catch (error) {
    console.error('查询测试申请材料列表时出错:', error);
  }
};

const fetchVehicleTypeList = async () => {

  try {
    if (!categoryCode.value) {
      console.warn('缺少必要的路由参数');
      return;
    }
    let params = {
      categoryType: categoryType.value
    };
    const response = await getVehicleTypeList(params);
    if (response.code === 200 && response.data) {
      testVehicleTypeList.value = response.data;
    } else {
      message.error('获取车辆类型列表失败');
    }
  } catch (error) {
    console.error('查询车辆类型列表时出错:', error);
  }
}



// 监听categoryInfo变化，更新categoryId
watch(() => categoryInfo.value?.id, (newId) => {
  categoryId.value = newId || '';
}, { immediate: true });

onMounted(() => {
  fetchCategoryInfo();
  fetchApplicationMaterials();
  fetchVehicleTypeList();
});

// 在组件挂载时初始化数据
onMounted(() => {
  // 初始化逻辑
});

// 监听applicationId变化，加载对应申请信息
watch(() => applicationId.value, (newId) => {
  if (newId) {
    fetchApplicationData(newId);
  }
}, { immediate: true });

</script>

<style scoped lang="less">
.main-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  overflow: hidden;
}

.header-section {
  flex-shrink: 0;
  padding: 12px 12px 0 12px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  z-index: 10;
}

.info-area {
  margin-bottom: 20px;
  padding: 10px 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
}

.area-title {
  margin-top: 0;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9d9d9;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.area-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9d9d9;
}

.area-title-wrapper .area-title {
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.select-vehicle-btn {
  padding: 4px 12px;
  font-size: 14px;
  height: 32px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.info-label {
  width: 100px;
  font-size: 15px;
  color: #666;
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  color: #333;
  word-break: break-all;
  font-size: 15px;
}

.back {
  position: fixed;
  top: 93px;
  right: 50px;
  z-index: 20;
}

.back-button {
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.back-button:hover {
  background-color: #40a9ff;
}

.back-button:active {
  background-color: #096dd9;
}

.content-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 40px;
  margin: 0 auto;
  width: 100%;
}

// 人员列表相关样式
.personnel-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.personnel-card {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.personnel-list-card {
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 7px;
  margin-bottom: 7px;
}

.personnel-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// 车架号头部区域
.frame-number-header {
  background-color: #fafafa;
  padding: 7px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.frame-number-info {
  display: flex;
  align-items: center;
}

.frame-number-label {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}

.frame-number-value {
  font-size: 16px;
  font-weight: 400;
  color: #333;
}

// 人员信息区域
.personnel-info-section {
  padding: 12px;
}

.personnel-details-row {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: nowrap;
  gap: 15px;
}

.detail-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}

.detail-label {
  color: #666;
  font-size: 14px;
}

.detail-value {
  color: #333;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
}

// 不同项目的宽度设置
.name-item {
  flex: 0 0 auto;
  min-width: 120px;
}

.gender-item {
  flex: 0 0 auto;
  min-width: 100px;
}

.phone-item {
  flex: 0 0 auto;
  min-width: 180px;
}

.id-item {
  flex: 0 0 auto;
  min-width: 280px;
}

.type-item {
  flex: 0 0 auto;
  min-width: 100px;
}

.date-item {
  flex: 0 0 auto;
  min-width: 140px;
}

.actions-item {
  display: flex;
  white-space: nowrap;
  margin-left: auto !important;
  min-width: 120px;
  justify-content: flex-end;
}

// 操作按钮区域
.action-section {
  padding: 12px;
  border-top: 1px solid #e8e8e8;
  background-color: #fafafa;
  display: flex;
  justify-content: flex-end;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 选择安全员弹框样式 */
.select-personnel-modal-content {
  max-height: 500px;
  overflow-y: auto;
}

.no-data {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}

.personnel-select-table {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
}

.personnel-table-header {
  display: flex;
  background-color: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 600;
  color: #333;
}

.table-header-item {
  padding: 10px 16px;
  text-align: left;
}

.table-header-item:nth-child(1) {
  width: 12%;
}

.table-header-item:nth-child(2) {
  width: 8%;
}

.table-header-item:nth-child(3) {
  width: 15%;
}

.table-header-item:nth-child(4) {
  width: 25%;
}

.table-header-item:nth-child(5) {
  width: 25%;
}

.table-header-item:nth-child(6) {
  width: 15%;
}

.personnel-select-list {
  display: flex;
  flex-direction: column;
}

.personnel-select-card {
  display: flex;
  padding: 0;
  border: none;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #fff;
}

.personnel-select-card:last-child {
  border-bottom: none;
}

.personnel-select-card:hover {
  border-color: #1890ff;
  box-shadow: none;
  background-color: #d9f2ff;
}

.table-personnel-info {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
}

.table-info-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  color: #333;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-info-item:nth-child(1) {
  width: 12%;
}

.table-info-item:nth-child(2) {
  width: 8%;
}

.table-info-item:nth-child(3) {
  width: 15%;
}

.table-info-item:nth-child(4) {
  width: 25%;
}

.table-info-item:nth-child(5) {
  width: 25%;
}

.table-info-item:nth-child(6) {
  width: 15%;
}

/* 材料列表样式 */
.document-item {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #fafafa;
}

.document-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.document-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
}

.document-description {
  color: #666;
  margin-bottom: 12px;
  font-size: 14px;
}

.document-upload {
  margin-top: 10px;
}

.content-steps {
  padding-left: 200px;
  padding-right: 200px;
}

.notice-container {
  //background: #f7f9fc;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 24px ;
  margin: 10px 0;
}

.notice-title {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  text-align: center;
}

.notice-content {
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.notice-list {
  padding-left: 24px;
  margin: 0;
}

.notice-item {
  color: #595959;
  margin-bottom: 16px;
  text-align: justify;
}

.policy-link {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s;
}

.policy-link:hover {
  color: #40a9ff;
  text-decoration: underline;
}

.notice-item:last-child {
  margin-bottom: 0;
}

.notice-agreement {
  text-align: center;
  margin-top: 24px;
}

.notice-agreement :deep(.ant-checkbox-wrapper) {
  font-size: 14px;
  color: #595959;
}

.form-actions {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

:deep(.ant-card) {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

// 自定义滚动条样式
.content-wrapper::-webkit-scrollbar {
  width: 6px;
}

.content-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.content-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

// 减小表格空状态的边距
:deep(.ant-empty-normal) {
  margin: 0 0;
}

:deep(.ant-table-cell) {
  padding: 8px 23px !important;
}

// 响应式设计
@media (max-width: 768px) {
  .content-wrapper {
    padding: 16px;
  }

  .back {
    position: relative;
    top: 0;
    right: 0;
    margin-bottom: 20px;
  }
}
</style>